import { TWidgetResult } from '../../../../shared/types/api';
import { IWidgetResultObserver } from '../../../../shared/types/widgetResultObserver';

export const createWidgetResultObserver = (): IWidgetResultObserver => {
  let resolver: (result: TWidgetResult) => void;

  const get = (): Promise<TWidgetResult> => {
    return new Promise<TWidgetResult>(resolve => {
      resolver = resolve;
    });
  };

  const resolve = (result: TWidgetResult): void => {
    resolver(result);
  };

  return {
    get,
    resolve,
  };
};
